import { Injectable, ElementRef, EventEmitter, Output, Injector } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';

import { Map, View, layer, source, Feature, proj, interaction, format, style, control, Overlay, geom, extent } from 'openlayers';

import { Configuration } from '../../configurations/shared.config';
import { DirectionsServiceRequestObject } from '../../dataModels/data-models';
import { DiagnosedItem } from '../../dataModels/diagnosed-item';

declare var $: any;
declare var google: any;
declare var Geocoder, ol;
@Injectable()
export class MapService extends DiagnosedItem {
    private map: Map;
    private View: View;
    zoom: number;
    mapType: string;
    centerX: number;
    centerY: number;
    mapUrl: string;
    minZoom: number;
    maxZoom: number;
    hideVehicle: boolean = false;
    isGoogleMode = false;
    public overlay: any;
    drawingGraphicsLayer: ol.layer.Vector;
    private geofencesGraphicsLayer: layer.Vector;
    private drawingGraphicSource: any = new ol.source.Vector({});
    geofencesGraphicSource: ol.source.Vector = new ol.source.Vector({});
    RoutingResultEvent: EventEmitter<any> = new EventEmitter();
    MapLoaded: EventEmitter<boolean> = new EventEmitter();
    ZoomLevelChange: EventEmitter<number> = new EventEmitter();
    selectedLocation: EventEmitter<any> = new EventEmitter();
    satelliteLayer: any;
    baseMapLayer: any;
    private wktFormat: ol.format.WKT = new ol.format.WKT({ splitCollection: true });
    Colors: any;
    currentFeature: any;
    MapDefaultSize: any;
    trafficLayer: any;
    gmap: any;
    isSatelliteMode: boolean = false;
    showMapControls: boolean = true;
    enableHideOverlay: boolean = true;
    @Output() revGeocodingResult: EventEmitter<any> = new EventEmitter();
    public MapID: string;
    constructor(private _http: Http, protected injector: Injector) {
        super(injector);
        this.drawingGraphicsLayer = new ol.layer.Vector({ source: this.drawingGraphicSource });
        this.geofencesGraphicsLayer = new ol.layer.Vector({ source: this.geofencesGraphicSource });
        this.Colors = {
            route1: '#d50082',
            route2: '#00ae63',
            route3: '#3b3b3b',
            route4: '#00cdeb',
            route5: '#a52a2a',
            route6: '#0041b9',
            route7: '#006400',
            route8: '#514325',
            route9: '#008b8b',
            route10: '#ff8700'
        };
    }

    public setMapSettings(_centerLong, _centerLat, _zoom, _containerId: string, _baseMapType, geocoding: boolean, MapUrl: string, minZoom: number, maxZoom: number) {
        this.drawingGraphicsLayer = new ol.layer.Vector({ source: this.drawingGraphicSource });
        this.geofencesGraphicsLayer = new ol.layer.Vector({ source: this.geofencesGraphicSource });
        // Check Map configuration params and if no params set default configurations
        this.checkMapParameters(_centerLong, _centerLat, _zoom, _baseMapType, MapUrl, minZoom, maxZoom);
        var self = this;

        this.satelliteLayer = new ol.layer.Tile({
            source: new ol.source.XYZ({ url: "http://mt0.google.com/vt/hl=en&x={x}&y={y}&z={z}&s=Ga&lyrs=y,traffic%7Cseconds_into_week:-1&style=XXX" }),
            title: 'Google',
            type: 'base',

        });
        if (this.mapType.toLowerCase() == "osm") {
            this.baseMapLayer = new ol.layer.Tile({
                source: new ol.source.OSM(),
                type: 'base'
            });
        }
        else if (this.mapType.toLowerCase() == "google") {
            this.isGoogleMode = true;
            this.baseMapLayer = new ol.layer.Tile({
                source: new ol.source.XYZ({ url: "https://mts0.google.com/vt?hl=en&src=app&x={x}&y={y}&z={z}&s=&lyrs=m@221000000,traffic%7Cseconds_into_week:-1&style=XXX" }),
                title: 'Google',
                type: 'base',

            });
        }
        else {
            this.baseMapLayer = new ol.layer.Tile({
                source: new ol.source.XYZ({ url: this.mapUrl }),
                type: 'base'
            });
        }

        var mousePositionControl = new ol.control.MousePosition({
            coordinateFormat: ol.coordinate.createStringXY(4),
            projection: 'EPSG:4326',
            className: 'custom-mouse-position',
            target: document.getElementById('mouse-position'),
            undefinedHTML: '&nbsp;'
        });

        this.map = new ol.Map({
            controls: ol.control.defaults({
                attributionOptions: ({
                    collapsible: false
                })
            }).extend([mousePositionControl]),
            view: new ol.View({
                center: proj.fromLonLat([this.centerX, this.centerY], 'EPSG:3857'),
                zoom: this.zoom,
                minZoom: this.minZoom,
                maxZoom: this.maxZoom
            }),
            layers: [
                this.baseMapLayer,

                this.drawingGraphicsLayer,
                this.geofencesGraphicsLayer
            ],
            target: this.MapID
        });

        this.map.updateSize();
        this.drawingGraphicsLayer.setZIndex(100);

        this.baseMapLayer.DisplayName = "baseMap";
        this.satelliteLayer.DisplayName = "satellite";
        this.MapLoaded.emit(true);
        var xthis = this;
        if (this.enableHideOverlay) {
            this.map.getView().on('change:resolution', function (e) {
                if (!xthis.hideVehicle)
                    xthis.hideOverlay(xthis.map.getView().getZoom());
            });
        }
        // this.baseMapLayer.changed();
        var map: any = this.map;
        this.MapDefaultSize = map.getSize();
        if (!this.isGoogleMode && this.showMapControls)
            this.addOSMGeoCoderControl();
    }
    public switchBaseMapView() {
        //  var isVisible = this.baseMapLayer.getVisible();
        // this.satelliteLayer.setVisible(isVisible);
        // this.baseMapLayer.setVisible(!isVisible);
        if (!this.isSatelliteMode) {
            this.map.getLayers().insertAt(0, this.satelliteLayer);
            this.map.removeLayer(this.baseMapLayer);
            this.isSatelliteMode = true;
        }
        else {
            this.map.getLayers().insertAt(0, this.baseMapLayer);
            this.map.removeLayer(this.satelliteLayer);
            this.isSatelliteMode = false;
        }


    }
    public addOSMGeoCoderControl() {
        var geocoder = new Geocoder('nominatim', {
            targetType: 'glass-button',
            lang: 'en',
            placeholder: 'Search for ...',
            limit: 5,
            keepOpen: false,
            autoComplete: true,
            autoCompleteMinLength: 3,

        });

        this.map.addControl(geocoder);
        // this.map.addOverlay(popup);
        geocoder.on('addresschosen', function (evt) {
            window.setTimeout(function () {
                // popup.show(evt.coordinate, evt.address.formatted);
            }, 3000);
        });
    }
    public addGoogleGeoCoderControl() {

        var input = document.getElementById('searchTextField');

        var autocomplete = new google.maps.places.Autocomplete(input);
        var self = this;
        autocomplete.addListener('place_changed', () => {
            var place = autocomplete.getPlace();
            this.deleteFeature(1, this.drawingGraphicSource);
            var feature = self.addFeatureOnMap(1, 'POINT(' + place.geometry.location.lng() + ' ' + place.geometry.location.lat() + ')', self.drawingGraphicSource, "red", "");

            self.centerMap(place.geometry.location.lng(), place.geometry.location.lat(), 16);
        });
    }
    public changeTrafficLayerVisible(enableTraffic: boolean) {
        if (!enableTraffic) {
            this.baseMapLayer.setSource(new ol.source.XYZ({ url: "http://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}" }));
            this.satelliteLayer.setSource(new ol.source.XYZ({ url: "http://mt0.google.com/vt/hl=en&x={x}&y={y}&z={z}&s=Ga&lyrs=y" }));
        }
        else {
            this.baseMapLayer.setSource(new ol.source.XYZ({ url: "https://mts0.google.com/vt?hl=en&src=app&x={x}&y={y}&z={z}&s=&lyrs=m@221000000,traffic%7Cseconds_into_week:-1&style=XXX" }));
            this.satelliteLayer.setSource(new ol.source.XYZ({ url: "http://mt0.google.com/vt/hl=en&x={x}&y={y}&z={z}&s=Ga&lyrs=y,traffic%7Cseconds_into_week:-1&style=XXX" }));
        }
        this.satelliteLayer.changed();
        this.baseMapLayer.changed();
    }
    public EnableFollowMode(hide: boolean) {
        this.hideVehicle = hide;
    }
    public UpdateMapSize() {
        this.map.updateSize();
    }

    addRoute(points) {
        const polygon = 'LINESTRING(' + points.map(x => x.lng + ' ' + x.lat).join(', ') + ')';
        this.addFeatureOnMap(1, polygon, this.drawingGraphicSource, "red", "");
    }

    public getLatLongFromMapClick() {
        var xthis: any = this;
        if (this.getMapObject() != null) {

            this.map.on('pointermove', function (e) {
                var mapElem = document.getElementById(xthis.map.getTarget());
                mapElem.style.cursor = 'crosshair';
            });

            this.map.on("click", function (e) {
                var coords = e.coordinate;
                coords = proj.transform(coords, 'EPSG:3857', 'EPSG:4326');
                // lat , lng
                var addressResult = { 'lat': coords[1], 'lng': coords[0] };
                if (xthis.drawingGraphicSource.getFeatures().length > 0)
                    xthis.deleteFeature(1, xthis.drawingGraphicSource);
                var feature = xthis.addFeatureOnMap(1, 'POINT(' + addressResult.lng + ' ' + addressResult.lat + ')', xthis.drawingGraphicSource, "red", "");
                xthis.map.getView().setCenter(feature.getGeometry().getLastCoordinate());
                //   xthis.map.getView().setZoom(11);
                // console.log('result', addressResult);
                xthis.revGeocodingResult.emit(addressResult);
            });
        }
    }

    public selectPointFromMapClick() {
        var xthis = this;
        if (this.getMapObject() != null) {
            this.getMapObject().on("click", function selectClick(e) {
                var coords = e.coordinate;
                coords = proj.transform(coords, 'EPSG:3857', 'EPSG:4326');
                if (xthis.drawingGraphicSource.getFeatures().length > 0)
                    xthis.deleteFeature(1, xthis.drawingGraphicSource);
                var feature = xthis.addFeatureOnMap(1, 'POINT(' + coords[0] + ' ' + coords[1] + ')', xthis.drawingGraphicSource, "red", "");
                xthis.getMapObject().un('click', selectClick);
                xthis.selectedLocation.emit(coords);
            });
        }
    }

    public unregisterMapClick() {
        var map: any = this.map;
        map.removeEventListener('click');

    }

    public getMapObject() {

        return this.map;
    }

    public zoomToFeature(_feature: Feature) {
        var map: any = this.map;
        var extent = _feature.getGeometry().getExtent();
        this.map.getView().fit(extent, map.getSize());
    }

    public getGraphicSource(type) {
        if (type == 'draw') {
            return this.drawingGraphicSource;
        }
        else {
            //return this.geofencesGraphicSource
        }
    }

    public addInteraction(_interaction: any) {
        this.map.addInteraction(_interaction);
    }

    public removeInteraction(_interaction: any) {
        this.map.removeInteraction(_interaction);
    }
    public getPointExtent(geometryString) {
        var geofenceFeature = this.wktFormat.readFeature(geometryString);
        var geometry = geofenceFeature.getGeometry().transform("EPSG:4326", "EPSG:3857");
        geofenceFeature.setGeometry(geometry);
        var extent = geofenceFeature.getGeometry().getExtent();
        return extent;
    }
    public MergeExtent(ExtentList) {
        var finalExtent = extent.createEmpty();
        ExtentList.forEach(function (ex) {
            extent.extend(finalExtent, ex);
        });
        if (ExtentList.length > 1) {
            this.map.getView().fit(finalExtent, this.MapDefaultSize);
        }
        else {
            var c = extent.getCenter(finalExtent);
            this.map.getView().setCenter(c);
            var curern = this.map.getView().getZoom();
            if (curern != 16)
                this.map.getView().setZoom(16);
        }

    }
    public GetMapExtent() {
        return this.map.getView().calculateExtent(this.map.getSize());
    }
    public ZoomToArea(extent33) {
        var GLOBE_WIDTH = 256; // a constant in Google's map projection
        var west: any = extent.getBottomLeft(extent33);
        var east: any = extent.getTopRight(extent33);
        var angle = extent33[0] - extent33[1];
        if (angle < 0) {
            angle += 360;
        }
        var zoom = Math.round(Math.log(360 / angle / GLOBE_WIDTH) / Math.LN2);
        console.log(zoom);
    }
    public addFeatureOnMap(featureId, geometryString, source, featureColor, labelText: string = "", offsetY: number = 0, src: string = "") {
        var geofenceFeature = this.wktFormat.readFeature(geometryString);
        var geometry = geofenceFeature.getGeometry().transform("EPSG:4326", "EPSG:3857");
        geofenceFeature.setGeometry(geometry);
        geofenceFeature.setId(featureId);

        var type = geofenceFeature.getGeometry().getType();
        if (type == 'Point') {

            var options: any = {
                text: labelText,
                textBaseline: 'bottom',
                font: '14px sans-serif',
                Weight: 'Bold',
                offsetY: offsetY,
                stroke: new ol.style.Stroke({
                    color: '#FFE000',
                    width: 2
                })
            };
            geofenceFeature.setStyle(new ol.style.Style({
                image: new ol.style.Icon(({
                    color: featureColor,
                    crossOrigin: 'anonymous',
                    src: src == "" ? 'https://openlayers.org/en/v4.1.1/examples/data/dot.png' : src
                })),
                text: new ol.style.Text(options)
            }));
        }
        else {
            geofenceFeature.setStyle(new ol.style.Style({
                stroke: new ol.style.Stroke(({
                    color: featureColor,
                    width: 5
                }))
            }));
        }
        source.addFeature(geofenceFeature);
        //source.refresh();
        return geofenceFeature;
    }

    public deleteFeature(featureId, source) {
        var feature = source.getFeatureById(featureId);
        if (feature)
            source.removeFeature(feature);
        source.refresh();
    }

    public createGraphicLayer() {
        //var graphicSource = new source.Vector({});
        var graphicLayer = new layer.Vector({ source: new source.Vector({}) });
        this.map.addLayer(graphicLayer);
        return graphicLayer;
    }

    public DeleteGraphicLayer(layer) {
        this.map.removeLayer(layer);
    }

    public clearLayerGraphics(layer) {
        if (layer) {
            layer.getSource().clear();
        }
    }

    public UpdateGraphicLayerSource(layer, features, isEsriFormat: boolean) {

        var wktFeatures = [];
        var formattedFeatures = features;
        var gSource = new source.Vector({});
        layer.setSource(gSource);
        if (isEsriFormat) {
            formattedFeatures = this.formatEsriJson(features);
            gSource.addFeatures(formattedFeatures);
            gSource.refresh();
            for (var feat of formattedFeatures) {
                if (feat.getGeometry()) {
                    var lineCords = feat.getGeometry().getCoordinates();
                    if (lineCords[0][0].constructor === Array) {
                        var cords = [];
                        for (var item of lineCords)
                            for (var elem of item)
                                cords.push(elem);
                        var newGeom = new geom.LineString(cords);
                        feat.setGeometry(newGeom);
                    }

                    var wktObject = { "BusId": feat.getId(), "wkt": this.wktFormat.writeFeature(feat, { "dataProjection": 'EPSG:4326', "featureProjection": 'EPSG:3857' }), "attributes": feat };
                    wktFeatures.push(wktObject);
                }
            }
        }
        return wktFeatures;
    }

    public addGeoJsonOnMap(layer, geoJsonObject) {
        layer.setSource(this.formatGeoJson(geoJsonObject));
    }

    public addOverlay(lat, long, divId, isHiden: boolean = false) {
        var pos = proj.transform([lat, long], 'EPSG:4326', 'EPSG:3857');
        var ov = this.getOverLayById(divId)
        if (ov == null) {
            this.overlay = new ol.Overlay({
                position: pos,
                positioning: 'center-center',
                element: document.getElementById(divId),
                stopEvent: false,
            });
            this.overlay.setPosition(pos);
            this.overlay.id = divId;

            // this.overlay.setElement(document.getElementById(divId));
            this.map.addOverlay(this.overlay);
            //document.getElementById(divId).hidden=isHiden;
            return this.overlay;
        }
        else {
           ov.setPosition(pos);
            //   document.getElementById(divId).hidden=isHiden;
            ov.setElement(document.getElementById(divId));
            return ov;
        }

    }

    public computeHeading(x, y, x1, y1) {
        var start = proj.transform([x, y], 'EPSG:4326', 'EPSG:3857');
        var end = proj.transform([x1, y1], 'EPSG:4326', 'EPSG:3857');
        var lat1 = start[0] * Math.PI / 180;
        var lat2 = end[0] * Math.PI / 180;
        var lng1 = start[1] * Math.PI / 180;
        var lng2 = end[1] * Math.PI / 180;


        return Math.atan2(Math.sin(lng2 - lng1) * Math.cos(lat2), Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1)) * 180 / Math.PI;
    }

    public computeHeading2(lat1, lng1, lat2, lng2) {
        var dLon = (lng2 - lng1);
        var y = Math.sin(dLon) * Math.cos(lat2);
        var x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);
        var brng = this._toDeg(Math.atan2(y, x));
        return 360 - ((brng + 360) % 360);
    }

    _toDeg(rad) {
        return rad * 180 / Math.PI;
    }

    public setOverlayPosition(lat, long, divId, overlay, isLiveTraking = false, isHiden: boolean = false) {
        if (overlay) {
            //  this.isOverlayAddedToMap();
            var pos = proj.transform([lat, long], 'EPSG:4326', 'EPSG:3857');
            overlay.setPosition(pos);

            if (isLiveTraking)
            overlay.setElement(null);

            overlay.setElement(document.getElementById(divId));
            var Element = overlay.getElement();
            if (Element)
                Element.hidden = isHiden;
            return overlay;
        }
        //else {
        //    return this.addOverlay(lat, long, divId);
        //}

    }

    isOverlayAddedToMap() {
        let overlays: any = this.map.getOverlays();
        if (overlays.a.length == 0)
            this.map.addOverlay(this.overlay);
    }

    hideOverlay(zoom) {
        let overlays: any = this.map.getOverlays();
        for (let l of overlays.a) {
            var Element = l.getElement();
            if (Element) {
                if (zoom < 8)
                    Element.hidden = true;
                else
                    Element.hidden = false;
            }
        }
    }

    public hiddenOverLayById(overlayId, IsHide) {
        let overlays: any = this.map.getOverlays();
        var index = overlays.a.findIndex(p => p.id == overlayId);
        if (index > -1) {
            var Element = overlays.a[index].getElement();
            if (Element) {
                Element.hidden = IsHide;
            }
        }
    }
    public removeOverlay(overlay) {

        if (overlay)
            this.map.removeOverlay(overlay);
    }

    public removeOverLayById(Id) {
        let overlays: any = this.map.getOverlays();
        var index = overlays.a.findIndex(p => p.id == Id);
        if (index > -1)
            this.map.removeOverlay(overlays.a[index]);
    }

    public removeAllOverlay() {
        let overlays: any = this.map.getOverlays();
        overlays.clear();
        //for (let l of overlays.a) {
        //     this.map.removeOverlay(l);
        //} 

    }

    public formatEsriJson(features) {
        var esrijsonFormat = new format.EsriJSON();
        var formattedFeaturs = [];
        for (var feat of features) {
            var feature: any = esrijsonFormat.readFeature(feat, { dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857' });
            // set bus ID for Route Feature ID
            feature.setId(Number(feat.attributes.Name.split("_")[1]));
            feature.TotalTime = feat.attributes.TotalTime;
            feature.TotalDistance = feat.attributes.TotalDistance;
            feature.StartTime = new Date(feat.attributes.StartTime);
            feature.EndTime = new Date(feat.attributes.EndTime);
            feature.Color = this.getRandomColor();
            feature.setStyle(new style.Style({
                stroke: new style.Stroke({
                    color: feature.Color,
                    width: 2.5
                })
            }));
            formattedFeaturs.push(feature);
        }
        return formattedFeaturs;
    }

    public formatGeoJson(geojsonObject) {
        var vectorSource = new source.Vector({
            features: (new format.GeoJSON()).readFeatures(geojsonObject)
        });
        return vectorSource;
    }

    centerMap(long, lat, zoom = null) {
        if (zoom)
            this.map.getView().setZoom(zoom);
        this.map.getView().setCenter(proj.fromLonLat([long, lat], 'EPSG:3857'));
    }

    highlightFeature(WktString, id, clearFeatures = false) {
        if (clearFeatures)
            this.drawingGraphicSource.clear();
        else {
            if (this.drawingGraphicSource.getFeatures().length >= 2) {
                this.drawingGraphicSource.removeFeature(this.currentFeature);
                this.drawingGraphicSource.refresh();
            }
        }
        var color = "#FF00FF"; // FUCHSIA  #40E0D0
        this.currentFeature = this.addFeatureOnMap(id, WktString, this.drawingGraphicSource, color);
        this.zoomToFeature(this.currentFeature);
    }

    getRandomColor() {
        var result;
        var count = 0;
        for (var prop in this.Colors)
            if (Math.random() < 1 / ++count)
                result = this.Colors[prop];

        return result;
    }

    calculateRoute(source: any, destination: any, wayPoints: string = "") {
        var requestObject = new DirectionsServiceRequestObject();
        var lineCords = [];

        var self = this;
        requestObject.source = source.Latitude + "," + source.Longitude;
        requestObject.destination = destination.Latitude + "," + destination.Longitude;
        if (wayPoints != "")
            requestObject.waypoints = wayPoints;
        this._http.post(Configuration.urls.webApiEndpoint + Configuration.urls.calculateRouteUrl, requestObject).subscribe(response => {
            if (response && response.ok) {
                var result = JSON.parse(response.text());
                if (result) {
                    result = result.Value;
                    var steps = result.routes[0].legs[0].steps;
                    var distance = result.routes[0].legs[0].distance.value;
                    distance = distance ? distance / 1000 : 0;
                    var duration = result.routes[0].legs[0].duration.value;
                    duration = duration ? duration / 60 : 0;
                    var routeLine = new geom.MultiLineString(null);
                    var wayPointsArrival = [];
                    for (var leg of result.routes[0].legs) {
                        var steps = leg.steps;
                        // array of leg waypoints that holds step_index of each waypoint
                        var legWaypoints = [];
                        legWaypoints = leg.via_waypoint;
                        if (steps) {
                            var waypointArrivalTime = 0;
                            for (var index in steps) {
                                var step = steps[index];
                                if (legWaypoints) {
                                    if (legWaypoints.findIndex(w => w.step_index == index) > -1) {
                                        wayPointsArrival.push(waypointArrivalTime / 60);
                                        // waypointArrivalTime = 0;
                                    }
                                    else
                                        waypointArrivalTime += step.duration.value; // value in seconds
                                }
                                var polylinePoints = this.decode(step.polyline.points);
                                // lineCords = [];
                                for (var point of polylinePoints)
                                    lineCords.push([point.longitude, point.latitude]);

                                //routeLine.appendLineString(new geom.LineString(lineCords));
                            }
                        }
                    }
                    var feature = new Feature({
                        geometry: new geom.LineString(lineCords)
                    });
                    var wktRoute = self.wktFormat.writeFeature(feature);
                    if (legWaypoints.length == 0) {
                        self.RoutingResultEvent.emit({ route: wktRoute, distance: distance, duration: duration });
                    }
                    else {
                        self.RoutingResultEvent.emit({ route: wktRoute, distance: distance, duration: duration, wayPointsArrival: wayPointsArrival });
                    }
                }

            }
        },
            error => {
                // alert('error');
            });
    }

    public getMapLayers() {
        return this.map.getLayers();
    }

    public createGraphicLayerWithId(id: string, Name: string): any {
        var graphicSource = new ol.source.Vector({});
        var graphicLayer: any = new ol.layer.Vector({ source: graphicSource });
        graphicLayer.id = id;
        graphicLayer.Name = Name;
        this.map.addLayer(graphicLayer);
        return graphicLayer;
    }

    public addEventOverLayOnMap(lat, long, overlayElement, evenTypeId, eventId) {
        var pos = proj.transform([lat, long], 'EPSG:4326', 'EPSG:3857');

        var overlay: any = new ol.Overlay({
            position: pos,
            positioning: 'top-center',
            element: overlayElement

        });
        overlay.setElement(overlayElement);
        overlay.id = eventId;
        overlay.evenTypeId = evenTypeId;
        this.map.addOverlay(overlay);

        return overlay;
    }
    public getOverLayById(overlayId) {
        let overlays: any = this.map.getOverlays();
        var index = overlays.a.findIndex(p => p.id == overlayId);
        if (index > -1)
            return overlays.a[index];
        else return null;

    }
    public getCenter() {
        var cords = this.getMapObject().getView().getCenter();
        return proj.transform(cords, 'EPSG:3857', 'EPSG:4326');
    }

    public getZoomLevel() {
        return this.getMapObject().getView().getZoom();
    }

    /* Private Methods */
    private decode(encoded) {

        // array that holds the points

        var points = []
        var index = 0, len = encoded.length;
        var lat = 0, lng = 0;
        while (index < len) {
            var b, shift = 0, result = 0;
            do {

                b = encoded.charAt(index++).charCodeAt(0) - 63;//finds ascii                                                                                    //and substract it by 63
                result |= (b & 0x1f) << shift;
                shift += 5;
            } while (b >= 0x20);


            var dlat = ((result & 1) != 0 ? ~(result >> 1) : (result >> 1));
            lat += dlat;
            shift = 0;
            result = 0;
            do {
                b = encoded.charAt(index++).charCodeAt(0) - 63;
                result |= (b & 0x1f) << shift;
                shift += 5;
            } while (b >= 0x20);
            var dlng = ((result & 1) != 0 ? ~(result >> 1) : (result >> 1));
            lng += dlng;

            points.push({ latitude: (lat / 1E5), longitude: (lng / 1E5) })

        }
        return points
    }

    // Check and validate map paramaters
    private checkMapParameters(centerLong, centerLat, zoom, baseMapType, MapUrl, minZoom, maxZoom): void {
        this.centerX = centerLong ? centerLong : Configuration.defaultMapParams.centerX;
        this.centerY = centerLat ? centerLat : Configuration.defaultMapParams.centerY;
        this.mapType = baseMapType ? baseMapType : Configuration.defaultMapParams.mapType;
        this.zoom = zoom ? zoom : Configuration.defaultMapParams.zoom;
        this.minZoom = minZoom ? minZoom : Configuration.defaultMapParams.minZoom;
        this.maxZoom = maxZoom ? maxZoom : Configuration.defaultMapParams.maxZoom;
        if (this.mapType.toLowerCase() != 'osm') {
            if (!MapUrl) {
                if (this.mapType == 'google')
                    this.mapUrl = Configuration.urls.GoogleMapUrl;
                else if (this.mapType == 'esri')
                    this.mapUrl = Configuration.urls.ESRIMapUrl;
            }
            else
                this.mapUrl = MapUrl;
        }
        else
            MapUrl = null;
    }

    public GetMapAddress(lat: number, lng: number): any {
        let geocoder = new google.maps.Geocoder();
        let latlng = new google.maps.LatLng(lat, lng);
        let request = {
            latLng: latlng
        };
        return new Promise((resolve, reject) => {
            geocoder.geocode(request, (results, status) => {
                if (status == google.maps.GeocoderStatus.OK) {
                    if (results[0] != null) {
                        resolve(results[0].formatted_address);
                    }
                } else resolve(null);

            });
        });
    }

}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/maps/map.service.ts